module.exports = __webpack_public_path__ + "static/media/nodejs.7e465682.png";